// Copied from /functions/problem-report/types.ts
export enum ProblemType {
    JoinClass = 'join_class',
    AudioQuality = 'audio_quality',
    VideoQuality = 'video_quality',
    ScreenSharing = 'screen_sharing',
    Recording = 'recording',
    RecordingPlayback = 'recording_playback',
    DialIn = 'dial_in',
    Other = 'other',
    Unspecified = 'unspecified'
}
